import { Component, OnInit } from '@angular/core';
import { ArchiveService } from '../../../services/archive/archive.service';
import { Archive } from '../../../models/archive/archive.model';
import * as _ from 'lodash';
import { UrlBuilderFactory } from '../../../shared/factories/url-builder.factory';

@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.css']
})
export class ArchiveComponent implements OnInit {
  
  archives:Array<Archive>;
  filters = {
    name:null,
    cpf:null,
    limit: { list: [5, 10, 50, 100], selected: 10 },
    skip: 0 
  }

  totalItems: number = 0;
  currentPage: number = 1;
  loading:Boolean;

  constructor(private archiveService:ArchiveService,
              private queryStringFactory: UrlBuilderFactory,) { }

  async ngOnInit() {
    this.loading = true;
    this.search();
    this.loading = false;
  }

  async search(page?:number){
    this.loading = true;
    this.currentPage = 1;
    this.archives = await this.archiveService.get(this.queryStringFactory.build(this.loadFilters(page)))
    this.loading = false;
  }

  loadFilters(page?) {
    this.currentPage = page ? page : (this.currentPage ? this.currentPage : 1);

    let filters = {};

    _.forOwn(this.filters, (value, key) => {
        const selected = _.get(value, 'selected', value);
        if (selected == 'undefined' || selected == null) return;

        filters[key] = selected;
    });

    return {
        ...filters,
        limit: this.filters.limit.selected,
        skip: (this.currentPage - 1) * this.filters.limit.selected
    };
}

}



// WEBPACK FOOTER //
// ./src/app/views/archive/archive/archive.component.ts